import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2f0a9799")
const _hoisted_1 = { class: "contents solution-area" }
const _hoisted_2 = { class: "inner flex-box jc-sb" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("SOLUTION")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("解決策")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("自分の進捗のみ表示")
const _hoisted_6 = { class: "img-box" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "description-area" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, " 受講者は自分の進捗のみ表示されるので、周りの進捗を見て焦ることはなくなります。 ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("匿名チャットで気軽に質問可能")
const _hoisted_9 = { class: "img-box" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "description-area" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, " 匿名で質問ができるので、初歩的なミスを気にすることなく質問ができます。 ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("講師は管理画面から全体の進捗を確認")
const _hoisted_12 = { class: "img-box" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "description-area" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, " 管理画面では全体の進捗に加えて、以下の作業ができます。 "),
  /*#__PURE__*/_createElementVNode("ul", { class: "features" }, [
    /*#__PURE__*/_createElementVNode("li", null, "進捗管理したい問題の追加・削除"),
    /*#__PURE__*/_createElementVNode("li", null, " チャットへの返信（講師が返信するとチャットの色が緑になります） "),
    /*#__PURE__*/_createElementVNode("li", null, "各問題の回答状況および回答時間の管理"),
    /*#__PURE__*/_createElementVNode("li", null, "勉強会の基本情報修正"),
    /*#__PURE__*/_createElementVNode("li", null, "講師、受講者への共有リンク取得")
  ])
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_head_english = _resolveComponent("top-head-english")!
  const _component_heading = _resolveComponent("heading")!
  const _component_retina_img = _resolveComponent("retina-img")!
  const _component_top_card = _resolveComponent("top-card")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_top_head_english, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_heading, {
        level: 2,
        textAlign: "left",
        isFullWidth: true
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_top_card, {
        widthType: "half",
        number: "01"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_heading, {
            level: 3,
            fontSize: "xl"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_retina_img, {
              src: "/images/ss-student-page.png",
              alt: "受講生の画面",
              width: 409,
              height: 232,
              loading: "lazy"
            })
          ]),
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_top_card, {
        widthType: "half",
        number: "02"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_heading, {
            level: 3,
            fontSize: "xl"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_retina_img, {
              src: "/images/ss-chat.png",
              alt: "質問画面",
              width: 411,
              height: 232,
              loading: "lazy"
            })
          ]),
          _hoisted_10
        ]),
        _: 1
      }),
      _createVNode(_component_top_card, { number: "03" }, {
        default: _withCtx(() => [
          _createVNode(_component_heading, {
            level: 3,
            fontSize: "xl"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_retina_img, {
              src: "/images/ss-management.png",
              alt: "管理画面",
              width: 960,
              height: 389
            })
          ]),
          _hoisted_13
        ]),
        _: 1
      })
    ])
  ]))
}